<span class="planner-radiobutton"
      [ngClass]="[getCheckedStatus() ? 'planner-radiobutton--' + this.radioClass : '', isDisabled ? 'disabled' : '']"
      (click)="check()"></span>
<button (click)="check()"
        [attr.id]="controlName"
        [disabled]="isDisabled"
        style="display: none;"></button>
